/**
 * @generated SignedSource<<a61abcff0584cd4fd11bee6aaca12e55>>
 * @relayHash 8a45d7e99df7abd28743c297cb4e2ab5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f2097d0cdf7382dc3ff14d6f4221cca6679714319f9242ed09793fe4a20c8e5c

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraRankMutationEdge = "BOTTOM" | "TOP" | "%future added value";
export type JiraRankMutationInput = {
  edge: JiraRankMutationEdge;
  issues: ReadonlyArray<string>;
  relativeToIssue: string;
};
export type useIssuesRanker_rankIssuesMutation$variables = {
  rankInput: JiraRankMutationInput;
};
export type useIssuesRanker_rankIssuesMutation$data = {
  readonly jira: {
    readonly rankIssues: {
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useIssuesRanker_rankIssuesMutation = {
  response: useIssuesRanker_rankIssuesMutation$data;
  variables: useIssuesRanker_rankIssuesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rankInput"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "rankInput",
            "variableName": "rankInput"
          }
        ],
        "concreteType": "JiraRankMutationPayload",
        "kind": "LinkedField",
        "name": "rankIssues",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIssuesRanker_rankIssuesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIssuesRanker_rankIssuesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "f2097d0cdf7382dc3ff14d6f4221cca6679714319f9242ed09793fe4a20c8e5c",
    "metadata": {},
    "name": "useIssuesRanker_rankIssuesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "807e857adafd2bfe0c31d05b225fd312";

export default node;
